/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { SegmentCategoryState } from '../state/SegmentCategoryState'
import SegmentationEvent from '../../event/SegmentationEvent'

class SegmentCategoryStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new SegmentCategoryState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SegmentationEvent.fetchOne:
        return state.merge(payload.segment_category)

      case SegmentationEvent.onEdit:
        return state.set(payload.name, payload.value)

      case SegmentationEvent.onClear:
        return state.clear()

      default:
        return state
    }
  }
}

export default new SegmentCategoryStore()
